import styled from 'styled-components';
import { Icon, P } from '@workramp/ui';
import { IconTextPair } from '~/features/common';
import isAddonEnabled from '~/is-addon-enabled';
import { useCreateContent } from '~/elc/features/content-creation';
import { MixPanel } from '~/common';
import { APP_CONSTANTS, AppState } from '~/common/explicit-exports';
import Dropdown from '../../../widget/dropdown';
import isFeatureEnabled from '../../is-feature-enabled';
import AssetPickerTypes from '../asset-picker-types';
import AssetPickerCreateAsset from './asset-picker-create-asset';

function AssetPickerCreateAssetDropdown({ itemFolderId, updateCallback }) {
  const createContent = useCreateContent();

  const handleCreate = (type) => {
    createContent({
      type,
      itemFolderId,
      onSuccess: () => {
        const assetName = AssetPickerTypes.getDisplayName(type);
        MixPanel.track(`admin_${assetName.toLowerCase()}_create`, { origin: 'left_sidebar' });

        if (type === AssetPickerTypes.FOLDER) {
          updateCallback();
        }
      },
    });
  };

  const activeIntegrations =
    window.getCurrentUser().enterprise.activeContentProviderIntegrations?.map((integration) => integration.slug) || [];
  const { isWhiteLabel } = AppState;

  const showChallenges = !isWhiteLabel && isAddonEnabled('revenueAddonEnabled') && !isFeatureEnabled('hide_challenges');
  const showEventTemplates = !isWhiteLabel && isFeatureEnabled('event_templates');
  const showWorkflows = !isWhiteLabel && isFeatureEnabled('workflows');
  const showGo1Content = !isWhiteLabel && isFeatureEnabled('go1_content_admin_card') && window.getCurrentUser().admin;
  const showUdemy = activeIntegrations.includes(APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY);
  const showLinkedInLearning = activeIntegrations.includes(
    APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING,
  );

  return (
    <div className="asset-picker--create-asset-dropdown">
      <Dropdown
        button={
          <DropdownButtonText size={1}>
            <IconTextPair icon={<Icon name="add:regular" size="match-font" />} text="Create New" />
          </DropdownButtonText>
        }
      >
        <AssetPickerCreateAsset type={AssetPickerTypes.FOLDER} onCreateClick={handleCreate} />
        <AssetPickerCreateAsset type={AssetPickerTypes.GUIDE} onCreateClick={handleCreate} />
        <AssetPickerCreateAsset type={AssetPickerTypes.SERIES} onCreateClick={handleCreate} />
        {showChallenges && <AssetPickerCreateAsset type={AssetPickerTypes.CHALLENGE} onCreateClick={handleCreate} />}
        {!isWhiteLabel && <AssetPickerCreateAsset type={AssetPickerTypes.UNIVERSITY} onCreateClick={handleCreate} />}
        <AssetPickerCreateAsset type={AssetPickerTypes.RESOURCE} onCreateClick={handleCreate} />
        <AssetPickerCreateAsset type={AssetPickerTypes.CLASS} onCreateClick={handleCreate} />
        {showWorkflows && <AssetPickerCreateAsset type={AssetPickerTypes.WORKFLOW} onCreateClick={handleCreate} />}
        {isFeatureEnabled('top_level_scorm') && (
          <AssetPickerCreateAsset type={AssetPickerTypes.SCORM} onCreateClick={handleCreate} />
        )}
        {showEventTemplates && (
          <AssetPickerCreateAsset type={AssetPickerTypes.EVENT_TEMPLATE} onCreateClick={handleCreate} />
        )}
        {showGo1Content && <AssetPickerCreateAsset type={AssetPickerTypes.GO1_CONTENT} onCreateClick={handleCreate} />}
        {showLinkedInLearning && (
          <AssetPickerCreateAsset type={AssetPickerTypes.LINKEDIN_LEARNING} onCreateClick={handleCreate} />
        )}
        {showUdemy && <AssetPickerCreateAsset type={AssetPickerTypes.UDEMY} onCreateClick={handleCreate} />}
      </Dropdown>
    </div>
  );
}

export default AssetPickerCreateAssetDropdown;

const DropdownButtonText = styled(P)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.on[600]};

  &:hover {
    color: ${({ theme }) => theme.colors.on[800]};
  }
`;
